import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { AppBar } from '../../components/material-ui/AppBar';
import { Fab } from '../../components/material-ui/Fab';
import { Toolbar } from '../../components/material-ui/Toolbar';
import { Typography } from '../../components/material-ui/Typography';
import { DialogControls } from '../../components/DialogControls/DialogControls';
import { ErrorBoundary } from '../../components/ErrorBoundary/ErrorBoundary';
import { Article } from './Article';
import { useModalProps } from '../../selectors/modals';
import { useStyles } from './useStyles';
import { useWhatsNewModalContent } from './useWhatsNewModalContent';

export const WhatsNewModalContent = memo(({ isAccepted }) => {
    const { title } = useModalProps();
    const { t: translate } = useTranslation();
    const { actionList, handleSetAccept } = useWhatsNewModalContent();

    const classes = useStyles();

    return (
        <ErrorBoundary>
            <AppBar className={classes.appBar}>
                <Toolbar className={classes.toolbar}>
                    <Typography className={classes.title}>{title}</Typography>
                    {isAccepted && <DialogControls actions={actionList} appBar={true} />}
                </Toolbar>
            </AppBar>
            <div className={classes.content}>
                <Article />
            </div>
            {!isAccepted && (
                <Fab className={classes.acceptBtn} color="primary" variant="extended" onClick={handleSetAccept}>
                    {translate('modal.reviewedContinue')}
                </Fab>
            )}
        </ErrorBoundary>
    );
});

WhatsNewModalContent.displayName = 'WhatsNewModalContent';
